import { create } from 'zustand';
import type { Device, FilterState } from '@/types';

interface DeviceState {
  devices: Device[];
  selectedDeviceId: string | null;
  filters: FilterState;
  setDevices: (devices: Device[]) => void;
  updateDevice: (deviceId: string, updates: Partial<Device>) => void;
  selectDevice: (deviceId: string | null) => void;
  setSearch: (search: string) => void;
  setStatusFilter: (status: FilterState['status']) => void;
  setOrganizationFilter: (organizationId: string | 'all') => void;
  setShowArchived: (showArchived: boolean) => void;
}

export const useDeviceStore = create<DeviceState>((set) => ({
  devices: [],
  selectedDeviceId: null,
  filters: { search: '', status: 'all', organizationId: 'all', showArchived: false },
  setDevices: (devices) => set({ devices }),
  updateDevice: (deviceId, updates) =>
    set((state) => ({
      devices: state.devices.map((d) =>
        d.id === deviceId ? { ...d, ...updates } : d
      ),
    })),
  selectDevice: (deviceId) => set({ selectedDeviceId: deviceId }),
  setSearch: (search) =>
    set((state) => ({ filters: { ...state.filters, search } })),
  setStatusFilter: (status) =>
    set((state) => ({ filters: { ...state.filters, status } })),
  setOrganizationFilter: (organizationId) =>
    set((state) => ({ filters: { ...state.filters, organizationId } })),
  setShowArchived: (showArchived) =>
    set((state) => ({ filters: { ...state.filters, showArchived } })),
}));
